"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function MobilePhone16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "mobile-phone-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M11,0 C12.1045695,0 13,0.8954305 13,2 L13,14 C13,15.1045695 12.1045695,16 11,16 L5,16 C3.8954305,16 3,15.1045695 3,14 L3,2 C3,0.8954305 3.8954305,0 5,0 L11,0 Z M11,13 L5,13 L5,14 L11,14 L11,13 Z M11,5 L5,5 L5,11 L11,11 L11,5 Z M11,2 L5,2 L5,3 L11,3 L11,2 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function MobilePhone16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(MobilePhone16Svg, Object.assign({}, svgProps)));
}
exports.default = MobilePhone16;
//# sourceMappingURL=MobilePhone16.js.map